import React from 'react';
import {
  Box,
  CircularProgress,
  CircularProgressProps,
  circularProgressClasses,
} from '@mui/material';

const CustomCircularProgress: React.FC<CircularProgressProps> = (props) => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      {/* Background Track */}
      <CircularProgress
        variant="determinate"
        sx={{
          color: '#e8e8e8', // Background ring color
        }}
        size={40}
        thickness={4}
        value={100}
        {...props}
      />

      {/* Spinning Foreground */}
      <CircularProgress
        variant="indeterminate"
        disableShrink
        sx={{
          color: '#828282', // Spinner color
          animationDuration: '1000ms', // Matches speed={2}
          position: 'absolute',
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round',
          },
        }}
        size={40}
        thickness={4}
        {...props}
      />
    </Box>
  );
};

export default CustomCircularProgress;
